var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('router-link',{attrs:{"to":_vm.to},nativeOn:{"click":function($event){return _vm.onRoute.apply(null, arguments)}}},[_c('span',[_vm._v(_vm._s(_vm.text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }